(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn();

    } else {
        RivalIQ.module('metrics.new.enums', function (enums) {
            enums.ListeningThemes = exportFn();
        });

    }

    // This is a set of fake themes based on the NB certified themes.
    // The underlying definitions for these themes are in the implementation of the data source.
    function exportFn() {

        return {
            excludeAds: {
                id: 'excludeAds',
                name: 'Exclude ads, sponsored posts, and job ads'
            },
            excludeCoupons: {
                id: 'excludeCoupons',
                name: 'Exclude coupons'
            },
            excludePornography: {
                id: 'excludePornography',
                name: 'Exclude pornography'
            },
            excludeAutopost: {
                id: 'excludeAutopost',
                name: 'Exclude autoposts'
            },
            excludeProfanity: {
                id: 'excludeProfanity',
                name: 'Exclude profanity'
            }
        };
    }
})();
